import React, { useState, useEffect } from 'react';
import { FiPlus, FiMinus } from "react-icons/fi";
import store from '../../redux/store/store';
import { db, storage } from '../../app-firebase/firebase';
import categories from '../../objects/categories';
import { connect } from 'react-redux';

import './product-form.scss';

const ProductForm = props => {

   const [images, setImages] = useState([]);
   const [imageInputs, setImageInputs] = useState([1]);

   const [cats, setCats] = useState([]);
   const [catInputs, setCatInputs] = useState([1]);

   const [descs, setDescs] = useState([]);
   const [descInputs, setDescInputs] = useState([1])

   const [ipNumber, setIpNumber] = useState('');
   const [isbn, setIsbn] = useState('');
   const [title, setTitle] = useState('');
   const [author, setAuthor] = useState('');
   const [subject, setSubject] = useState('');
   const [priceUsd, setPriceUsd] = useState('');
   const [priceCad, setPriceCad] = useState('');
   const [age, setAge] = useState('');
   const [weight, setWeight] = useState('');

   const [errors, setErrors] = useState([]);
   // const [existingIpNumbers, setExistingIpNumbers] = useState([])

   useEffect(() => {
      
      console.log(images);
      if (props.prod && props.op === 'update') {
         setIpNumber(props.prod.ipNumber);
         setIsbn(props.prod.isbn);
         setTitle(props.prod.title);
         setAuthor(props.prod.author);
         setSubject(props.prod.subject);
         setPriceUsd(props.prod.priceUsd);
         setPriceCad(props.prod.priceCad);
         setAge(props.prod.age);
         setWeight(props.prod.weight);
      }
      // setExistingIpNumbers(Object.values(store.getState().books).map(prod => {
      //    return prod.ipNumber
      // }));
   }, [props.op, props.prod, store]);

   const handleAddButton = e => {
      e.preventDefault();
      console.log(checkErrors());
   }

   const checkErrors = () => {
      const err = [];

      if (ipNumber && new RegExp(/^[0-9]*$/gm).test(ipNumber)) {
         if (props.existingIds.includes(ipNumber)) err.push('* IP number already exists on database');
      } else {
         err.push('* IP number is invalid');
      }

      if (!isbn) {
         err.push('* ISBN is required');
      }

      if (!title) {
         err.push('* Title is required')
      }

      if (!author) {
         err.push('* Author is required')
      }
      
      if (!priceUsd || !new RegExp(/^(\d*\.\d\d)$/igm).test(priceUsd)) {
         err.push('* USD price is invalid')
      }
      
      if (!priceCad || !new RegExp(/^(\d*\.\d\d)$/igm).test(priceCad)) {
         err.push('* CAD price is invalid')
      }
      setErrors(err);
      return err.length ? false : true;
   }

   const handleChangeImage = (e, index) => {
      console.log(e.target.files[0].name);
      const arr = [...images, e.target.files[0]];
      setImages(arr);
   }

   console.log(images);
   
   return (
      <form className="form logged-form-book">
         <legend>{props.operation.substring(0,1).toUpperCase() + props.operation.substring(1)} a Product</legend>
         {errors.length ?
            errors.map((val, index) => {
               return (
                  <div key={index} className="errors">
                     <div className="error"><span>{val}</span></div>
                  </div>
               )
            }):
            null
         }
         <div className="d-flex">
            <input type="text" placeholder="IP Number *" onChange={e => setIpNumber(e.target.value)}/>
            <input type="text" placeholder="ISBN *" onChange={e => setIsbn(e.target.value)}/>
         </div>
         <div className="d-flex">
            <input type="text" placeholder="Title *" className="w-100"  onChange={e => setTitle(e.target.value)}/>
         </div>
         <div className="d-flex">
            <input type="text" placeholder="Author *" onChange={e => setAuthor(e.target.value)}/>
            <input type="text" placeholder="Subject" onChange={e => setSubject(e.target.value)}/>
         </div>
         <div className="d-flex">
            <input type="text" placeholder="USD Price *" onChange={e => setPriceUsd(e.target.value)}/>
            <input type="text" placeholder="CAD Price *" onChange={e => setPriceCad(e.target.value)}/>
         </div>
         <div className="d-flex">
            <input type="text" placeholder="Age" onChange={e => setAge(e.target.value)}/>
            <input type="text" placeholder="Weight" onChange={e => setWeight(e.target.value)}/>
         </div>
         {
            imageInputs.map((img, index) => {
               return (
                  <div key={index} className="d-flex justify-content-between align-items-center">
                     <input id={`image-input-${imageInputs.length}`} type="file" className="longer-input" onChange={e => handleChangeImage(e,index)}/>
                     <span className="pf-plus" onClick={() => setImageInputs([...imageInputs, imageInputs.length + 1])}><FiPlus /></span>
                     {index ? <span className="pf-minus" onClick={() => setImageInputs(imageInputs.filter((v, i) => v !== index))}><FiMinus /></span> : null}
                  </div>
               )
            })
         }

         {
            catInputs.map((img, index) => {
               return (
                  <div key={index} className="d-flex justify-content-between align-items-center">
                     <select className="longer-input" onChange={e => setCats([...cats, e.target.value])}>
                        <option value="">Categories *</option>
                        {
                           Object.values(categories).map(cat => <option key={cat} value={cat}>{cat}</option>)
                        }
                     </select>
                     <span className="pf-plus" onClick={() => setCatInputs([...catInputs, catInputs.length])}><FiPlus /></span>
                     {catInputs.length ? <span className="pf-minus" onClick={() => setCatInputs(catInputs.slice(index, 1))}><FiMinus /></span> : null}
                  </div>
               )
            })
         }

         {
            descInputs.map((img, index) => {
               return (
                  <div key={index} className="d-flex justify-content-between align-items-center">
                     <textarea 
                        className="longer-input"
                        placeholder={'Description paragraph ' + (!index ? (index + 1) + ' *' : index + 1)}
                        onChange={() => setDescs([...descs, this])}></textarea>
                     <span className="pf-plus" onClick={() => setDescs([...descs, null])}><FiPlus /></span>
                     {index ? <span className="pf-minus" onClick={() => setDescs(descs.slice(1))}><FiMinus /></span> : null}
                  </div>
               )
            })
         }

         <button type="submit" className="btn btn-secondary pf-button" onClick={e => handleAddButton(e)}>{props.operation.substring(0,1).toUpperCase() + props.operation.substring(1)} Product</button>
      </form>
   )
}

const mapStateToProps = state => {
   return {
      existingIds: Object.values(state.books).map(book => book.ipNumber)
   }
}

export default connect(mapStateToProps)(ProductForm);
